import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchAdminStandards } from '@/api/(admin)/standards';
import type { AdminStandard } from '@/api/(admin)/standards/types';
import type { StandardsQueryInput } from '../-types';
import { buildStandardsQs, toStandardsParams } from '../-utils/listParams';

/** Prefix for every standards cache entry, so one invalidation clears the list. */
export const adminStandardsQueryKey = ['admin', 'standards'] as const;

/** Shared by the route loader and the page, so the prefetch warms what the page reads. */
export function adminStandardsQueryOptions(input: StandardsQueryInput) {
  const params = toStandardsParams(input);
  return queryOptions({
    queryKey: [...adminStandardsQueryKey, 'list', params] as const,
    queryFn: () => fetchAdminStandards(buildStandardsQs(params)),
  });
}

export function useAdminStandards(input: StandardsQueryInput) {
  const query = useQuery(adminStandardsQueryOptions(input));
  const rows: AdminStandard[] = query.data?.data ?? [];
  return {
    ...query,
    rows,
    totalCount: query.data?.metadata.pagination.total ?? 0,
  };
}
